<app-month-pager [availableMonths]="availableMonths()" (monthChange)="onMonthChange($event)" />

<app-notification-setup [history]="history()" [month]="selectedMonth()" (saved)="onSetupSaved()" />

<h2 class="section-title">
    {{ 'ADMIN.DAYS_LEFT.HISTORY_TITLE' | translate }}
</h2>

<app-notification-history [history]="history()" />